import { Component } from "react";
import moment from 'moment';

export class DatosValidacion extends Component {

    render() {
        let data = this.props.DatosValidacion;
        let EsRechazo = this.props.EsRechazo;
        return (

    <div id="DatosValidacion" className="card shadow mb-4">
        <div className="card-header">
            <h6 className="m-0 font-weight-bold text-primary">Datos de Validación</h6>
        </div>
        <div className="card-body text-gray-800">
            <div className="form-row">
                <div className="form-group col-md-6" style={{ display: EsRechazo ? '' : 'none' }}>
                    <label htmlFor="Validacion.TipoRechazo.Descripcion" className="col-form-label"> Tipo Rechazo</label>
                    <input type="text" id="Validacion.TipoRechazo.Descripcion" className="form-control" value={data.tipoRechazo?.descripcion??""} readOnly />
                </div>
                <div className="form-group col-md-3">

                    <label htmlFor="Validacion.UsuarioValida" className="col-form-label"> Usuario</label>
                    <input type="text" id="Validacion.UsuarioValida" className="form-control" value={data.usuarioValida} readOnly />
                </div>
                <div className="form-group col-md-3">

                    <label htmlFor="Validacion.FechaValidacion" className="col-form-label"> Validado</label>
                    <input type="text" id="Validacion.FechaValidacion" className="form-control"
                    value={data.fechaValidacion !== null? moment(data.fechaValidacion).format("DD/MM/YYYY HH:mm:ss"):"" } readOnly />
                </div>
            </div>
            <div className="form-row">
                <div className="form-group col-md-12">
                    <label htmlFor="Validacion.Motivo" className="col-form-label"> Motivo</label>
                    <textarea type="text" id="Validacion.Motivo" className="form-control" readOnly value={data.motivo??""}>  </textarea>
                </div>
            </div>
        </div>
    </div>
        );
    }

}

export default DatosValidacion;